import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import TextButton from "@components/elements/V2/Buttons/TextButton"
import Grid from "@components/elements/V2/Grid"
import IntroInfoCard from "@components/experiments/IntroInfoCard"
import LayoutSection from "@components/V2/LayoutComponents/LayoutSection"
import { Color } from "@constants/V2/color"
import { withPrefix } from "@utils/url"

// MARK: Experiment - hardcoded props for Counter markerting experiment
// move values onto the config object in Storyblok when ready

const GroupOfIntroInfoCards = ({ blok }: Storyblok.BlokProps<any>) => {
  return (
    <LayoutSection
      primaryBackgroundColor={Color.Charcoal}
      className="!pt-0"
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      <Grid>
        <IntroInfoCard
          iconUrl="/icons/experiments/circle-one.svg"
          heading="Buy your Yoco Counter at yoco.com"
          description={
            <p>
              Delivery is fast and free, anywhere in SA within 3 working days.
            </p>
          }
          linkText="Buy Now"
          linkUrl={withPrefix("/shop/yoco-counter/")}
        />
        <IntroInfoCard
          iconUrl="/icons/experiments/circle-two.svg"
          heading="Create a Yoco profile for your business"
          description={
            <ul className="[&_li]:ml-[16px] md:[&_li]:mb-4">
              <li>
                Download the{" "}
                <TextButton
                  linkUrl={withPrefix("/app")}
                  text="Yoco App"
                  color={Color.Blue}
                  style="text"
                  textSize="body-md"
                  uppercase={false}
                />
              </li>
              <li>
                Create your{" "}
                <TextButton
                  linkUrl={process.env.GATSBY_APP_DESKTOP_URL}
                  text="product catalogue"
                  color={Color.Blue}
                  style="text"
                  textSize="body-md"
                  uppercase={false}
                />
              </li>
              <li>
                Add{" "}
                <TextButton
                  linkUrl={process.env.GATSBY_APP_DESKTOP_URL}
                  text="staff profiles"
                  color={Color.Blue}
                  style="text"
                  textSize="body-md"
                  uppercase={false}
                />
              </li>
              <li>
                <TextButton
                  linkUrl={process.env.GATSBY_APP_DESKTOP_URL}
                  text="Personalise"
                  color={Color.Blue}
                  style="text"
                  textSize="body-md"
                  uppercase={false}
                />{" "}
                your Neo Touch screensaver
              </li>
            </ul>
          }
        />
        <IntroInfoCard
          iconUrl="/icons/experiments/circle-three.svg"
          heading="Unbox your Yoco Counter and start selling"
          description={
            <ul className="[&_li]:ml-[16px] md:[&_li]:mb-4">
              <li>Plug in and power it on</li>
              <li>Connect via Wi-Fi OR SIM card</li>
              <li>Login to your Yoco App</li>
              <li>Follow the steps to connect your Neo Touch card machine</li>
            </ul>
          }
        />
      </Grid>
    </LayoutSection>
  )
}

export default GroupOfIntroInfoCards
